import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import MeiliSearch from "meilisearch";
import { MainPage, ResultBox } from "styles/jss/Layout.styles";
import { Box, Button, Container, Grid } from "@mui/material";
import { Loader, NextImage } from "components/index";
import { PageContainer } from "components/PagesComponents";
import { truncateString } from "utils/helperFunction";
import Image from "next/image";
import { Page404 } from "../../styles/jss/Custom404.styles";

const SearchResult = () => {
  const { t } = useTranslation(["nav"]);
  const { locale, query } = useRouter();

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handle_search = useCallback(async () => {
    setLoading(true);
    const client = new MeiliSearch({
      host: process.env.MEILI_HOST,
      apiKey: process.env.MEILI_API_KEY,
    });
    const indexes = ["products", "news", "tender"];
    const results = (
      await Promise.all(
        indexes.map(async item => {
          const getIndex = await client.getIndex(item);
          const { hits: data } = await getIndex.search(query.search, {
            limit: 10000,
            offset: 0,
          });
          return data;
        }),
      )
    )
      .flat()
      .filter(item => item.locale === locale);
    setResults(results);
    setLoading(false);
  }, [query, locale]);

  useEffect(() => {
    handle_search().catch(err => {
      toast.error(err.toString());

      setLoading(false);
    });
  }, [handle_search]);

  return (
    <PageContainer title={`${t("search.result.title")} ${query.search}`}>
      <MainPage>
        <Container>
          {loading ? (
            <Loader />
          ) : !!results.length ? (
            <Grid container columnSpacing={{ md: 3 }} rowSpacing={3}>
              {results.map(item => {
                return (
                  <Grid item xs={12} md={6} key={item.id}>
                    <Link href={item.pageUrl} locale={locale}>
                      <a>
                        <ResultBox locale={locale} product={false}>
                          <Grid
                            container
                            className={"boxes"}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Grid item xs={12} sm={3}>
                              <Box className={"imageWrapper"}>
                                <NextImage
                                  src={item.image}
                                  alt={item.name}
                                  layout={"fill"}
                                  objectFit={"cover"}
                                  placeholder="blur"
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm className={"content"}>
                              <h3 className={"title"}>
                                {truncateString(item.name, 50)}
                              </h3>
                              <p className={"text"}>
                                {truncateString(item.short_description, 50)}
                              </p>
                            </Grid>
                          </Grid>
                        </ResultBox>
                      </a>
                    </Link>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <Box
              sx={{
                [Page404]: {
                  m: 0,
                },
              }}
            >
              <Page404>
                <div className="imageWrapper">
                  <Image
                    src={`/images/result_notFound.svg`}
                    alt={"result not found"}
                    width={220}
                    height={190}
                    layout={"responsive"}
                    objectFit={"cover"}
                  />
                </div>
                <p className="title">{t("search.result.notF-text")}</p>
              </Page404>
            </Box>
          )}
        </Container>
      </MainPage>
    </PageContainer>
  );
};

export default SearchResult;
